export default "__VITE_ASSET__M8je6G7e__"